<template>
  <v-navigation-drawer
    v-if="user"
    class="sidebar elevation-1"
    :mini-variant="$store.state.hidden_menu"
    v-model="drawer"
    :permanent="$vuetify.breakpoint.mdOnly"
    :temporary="$vuetify.breakpoint.smAndDown"
    disable-route-watcher
    stateless
    app
    :dark="$store.state.theme_mixed"
    hide-overlay
  >
    <v-list-item class="px-2 noHover" v-b-hover="false" style="height: 56px;">

      <v-list-item-avatar v-on:click="$router.push({path: '/perfil'})" class="avatar-pointer">

        <v-avatar v-if="avatar">
          <img
            class="ml-n2"
            :src="require(`@/assets/avatar/${srcAvatar}.png`)"
            :alt="user.first_name"
          >
        </v-avatar>

        <v-avatar v-else color="#CF112D">
          <span class="white--text text-h5 ml-n2">{{ user.first_name[0] }}{{ user.last_name[0] }}</span>
        </v-avatar>

      </v-list-item-avatar >
      <v-list-item-title class="text-center mr-10" v-if="user">{{ user.first_name }} {{ user.last_name }}
      </v-list-item-title>
    </v-list-item>
    <v-divider class="mt-2"></v-divider>

    <v-list-item
      class="text-decoration-none submenu noHover"
    >
      <v-list-item-icon class="noHover">
        <v-btn
          v-show="true"
          color="rgb(207, 17, 45)"
          fab
          dark
          x-small
          absolute
          right
          @click="$store.state.hidden_menu = !$store.state.hidden_menu"
          class="mr-n1 mt-n3 noHover"
        >
          <v-icon v-if="$store.state.hidden_menu">mdi-chevron-right</v-icon>
          <v-icon v-else>mdi-chevron-left</v-icon>
        </v-btn>
      </v-list-item-icon>
    </v-list-item>

    <!--      MENU      -->
    <v-list
      nav
      dense
      v-for="item in items.filter(item => check_permission(item.roles))"
      :key="item.title"
      link>

      <div v-if="'child' in item && item.child.length > 1">
<!--        <v-list-group-->
<!--          nav-->
<!--          dense-->
<!--          :prepend-icon="item.icon"-->
<!--          color="#CF112D"-->
<!--          @click="$store.state.hidden_menu = false"-->
<!--          no-action-->
<!--        >-->
        <v-list-group
          nav
          dense
          :color="$store.state.theme_mixed || $vuetify.theme.dark ? '#a1a1a1': '#CF112D'"
          :prepend-icon="item.icon"
          @click="$store.state.hidden_menu = false"
          no-action
        >
          <template v-slot:activator>
            <v-tooltip right :disabled="!$store.state.hidden_menu">
              <template v-slot:activator="{ on, attrs }">
                <v-list-item-content
                  v-bind="attrs"
                  v-on="on">
                  <v-list-item-title v-text="item.title"></v-list-item-title>
                </v-list-item-content>
              </template>
              <span>{{ item.title }}</span>
            </v-tooltip>
          </template>
          <v-list-item
            v-for="child in item.child.filter(child => check_permission(child.roles))"
            :key="child.title"
            :to="child.link"
            class="text-decoration-none submenu"
          >
            <v-list-item-icon>
              <v-icon v-text="child.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="child.title"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>

        </v-list-group>
      </div>
      <div v-else-if="'child' in item && item.child.length === 1">
        <v-tooltip right :disabled="!$store.state.hidden_menu">
          <v-list-item :to="item.child[0].link" class="text-decoration-none">
            <v-list-item-icon>
              <v-icon>{{ item.child[0].icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ item.child[0].title }}</v-list-item-title>
          </v-list-item>
          <span>{{ item.child[0].title }}</span>
        </v-tooltip>
      </div>
      <div v-else>
        <v-tooltip right :disabled="!$store.state.hidden_menu">
          <template v-slot:activator="{ on, attrs }">
            <v-list-item v-if="item.routeName !== 'estadisticas'" :to="item.link" class="text-decoration-none"
                         v-bind="attrs"
                         v-on="on">
              <v-list-item-icon>

                <v-badge
                  v-if="item.routeName === 'tareas' && taskLen > 0"
                  color="red"
                  :content="taskLen"
                >
                  <v-icon>{{ item.icon }}</v-icon>
                </v-badge>
                <v-icon v-else>{{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
            <v-list-item v-else @click="external(item.link)" class="text-decoration-none"
                         v-bind="attrs"
                         v-on="on">
              <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </template>
          <span>{{ item.title }}</span>
        </v-tooltip>
      </div>
    </v-list>

    <template v-slot:append>
      <v-list-item class="text-decoration-none darkToggle noHover">
        <v-tooltip right :disabled="!$store.state.hidden_menu">
          <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          class="ml-n1"
          icon
          @click="darkMode"
        >
          <v-icon class="darkToggle" dense v-if="$vuetify.theme.dark">mdi-white-balance-sunny</v-icon>
          <v-icon class="darkToggle" dense v-else-if="$store.state.theme_mixed">mdi-weather-night</v-icon>
          <v-icon class="darkToggle" dense v-else>mdi-theme-light-dark</v-icon>

        </v-btn>
          </template>
          <span  v-if="$vuetify.theme.dark">Modo Claro</span>
          <span v-else-if="$store.state.theme_mixed">Modo Oscuro</span>
          <span v-else >Modo Mixto</span>
        </v-tooltip>
      </v-list-item>
    </template>
  </v-navigation-drawer>
</template>
<script>
import {Role} from '@/js/roles'
import {authentication} from '@/js/authentication'
import Vue from "vue";
import store from "@/store";

export default {
  name: '_sidebar',
  data() {
    return {
      colorHead: this.$vuetify.theme.dark ? 'dark' : '#fff',
      devs: false,
      user: null,
      color: this.$vuetify.theme.dark ? '#DDD' : '#212121',
      linkColor: this.$vuetify.theme.dark ? '#DDD' : '#212121',
      drawer: true,
      mini: Vue.prototype.$user.hidden_menu,
      logout_icon: 'mdi-logout-variant',
      home: 'mdi-home-outline',
      items: [
        {
          title: 'Home',
          link: '/home',
          routeName: 'home',
          icon: 'mdi-home-outline',
          roles: [Role.levantador, Role.asistente, Role.ejecutivo, Role.jefe, Role.gerente, Role.developer, Role.administrador]
        },
        {
          title: 'Tareas',
          link: '/tareas',
          routeName: 'tareas',
          icon: 'mdi-calendar-check',
          roles: [Role.levantador, Role.asistente, Role.ejecutivo, Role.jefe, Role.gerente, Role.developer, Role.administrador]
        },
        {
          title: 'Propiedades',
          link: '/propiedades',
          routeName: 'propiedades',
          icon: 'mdi-office-building-marker-outline',
          roles: [Role.levantador, Role.asistente, Role.jefe, Role.ejecutivo, Role.developer]
        },
        {
          title: 'Cargar EXCEL',
          link: '/load_file',
          routeName: 'load_file',
          icon: 'mdi-file-upload-outline',
          roles: [Role.asistente, Role.jefe, Role.developer]
        },
        {
          title: 'Visualización',
          link: 'https://' + location.host + '/estadisticas.html',
          routeName: 'estadisticas',
          icon: 'mdi-chart-areaspline',
          roles: [Role.gerente, Role.developer, Role.jefe, Role.asistente]
        },
        {
          title: 'Visualización',
          link: 'https://' + location.host + '/estadisticas_e.html',
          routeName: 'estadisticas',
          icon: 'mdi-chart-areaspline',
          roles: [Role.developer, Role.ejecutivo]
        },
        {
          title: 'Administración',
          icon: 'mdi-cog-outline',
          roles: [Role.administrador, Role.developer, Role.jefe],
          child: [
            {
              title: 'Re-asignación',
              link: '/administracion/reasignacion',
              routeName: 'reasignacion',
              icon: 'mdi-account-switch-outline',
              roles: [Role.administrador, Role.developer, Role.jefe]
            },
            {
              title: 'Usuarios',
              link: '/administracion/usuarios',
              routeName: 'usuarios',
              icon: 'mdi-account-edit-outline',
              roles: [Role.administrador, Role.developer]
            },
            {
              title: 'Mi Grupo',
              link: '/administracion/mi_grupo',
              routeName: 'mi_grupo',
              icon: 'mdi-account-group-outline',
              roles: [Role.administrador, Role.developer, Role.jefe]
            },
            {
              title: 'Grupos',
              link: '/administracion/grupos',
              routeName: 'grupos',
              icon: 'mdi-select-group',
              roles: [Role.administrador, Role.developer]
            },
          ]
        },
        {
          title: 'Developer',
          link: '/developer',
          routeName: 'developer',
          icon: 'mdi-code-tags-check',
          roles: [Role.developer]
        },
        {
          title: 'Tutorial',
          link: '/tutorial',
          routeName: 'tutorial',
          icon: 'mdi-chat-question-outline',
          roles: [Role.developer]
        }
      ]
    }
  },
  watch: {
    mini(value) {
      Vue.prototype.$user.hidden_menu = value
    }
  },
  beforeCreate() {
    if (this.$vuetify.theme.dark) {
      document.querySelector('body').setAttribute('style', 'background:#272727')
    } else {
      document.querySelector('body').setAttribute('style', 'background:#fffffe')
    }
  },
  methods: {
    async external(link) {
      let obj_token = await this.$store.state.ioh.get_token()
      window.open(link + '?t=' + obj_token.token, '_blank')
    },
    check_permission(menu_roles) {
      const user_roles = Object.values(this.user.roles)
      const result = menu_roles.some(v => user_roles.includes(v))
      return result
    },

    darkMode() {
      if(this.$store.state.theme_mixed){
        this.user.config.theme_mixed = 0
        document.body.style.backgroundColor = '#272727'
        localStorage.setItem('currentUser', JSON.stringify(this.user))
        store.commit('changeThemeMixed', false)
        this.$vuetify.theme.dark = true
      } else if (this.$vuetify.theme.dark) {
        this.user.config.dark_mode = 0
        document.body.style.backgroundColor = '#fffffe'
        localStorage.setItem('currentUser', JSON.stringify(this.user))
        this.$vuetify.theme.dark = false
      } else {
        this.user.config.theme_mixed = 1
        document.body.style.backgroundColor = '#272727'
        localStorage.setItem('currentUser', JSON.stringify(this.user))
        store.commit('changeThemeMixed', true)
      }
    },
  },
  computed: {
    taskLen() {
      return Vue.prototype.$task.cant
    },
    avatar() {
      return Vue.prototype.$user.avatar
    },
    srcAvatar() {
      return Vue.prototype.$user.src_avatar
    },
  },
  created() {
    if (authentication.currentUserValue) {
      this.user = authentication.currentUserValue
      this.avatar = JSON.parse(localStorage.getItem('avatar'))
      this.$vuetify.theme.dark = authentication.currentUserValue.config.dark_mode === 1
    }
  },
  mounted() {
    document.body.style.setProperty('--main-color', this.color)
    this.devs = Vue.prototype.$devs.status
  }
}
</script>

<style scoped lang="scss">

.avatar-pointer {
  cursor: pointer;
}

.sidebar {
  max-height: 100% !important;
  height: 100% !important;
}

.v-list--nav{
  padding-right: 0 !important;
  margin-bottom: -4px;
}
.v-list-item__title, .v-list-item__subtitle{
  white-space: unset;
}

.v-list--nav .v-list-item, .v-list--nav .v-list-item:before{
  border-radius: 15px 0 0 15px;
}

.px-2.v-list-item.theme--light:hover{
  background-color: unset;
  opacity: 1;
  margin-left: unset;
  margin-right: unset;

  .v-list-item__title:hover {
    text-decoration: none;
    color: rgba(0, 0, 0, 0.87);
  }
}

.v-list-item--link:not(.darkToggle):before{
  background-color: #CF112D;
  margin-right: -10px;
  color: #fff;
}

.v-list-item--active:not(.darkToggle):before{
  background-color: #CF112D;
  margin-right: -10px;
  color: #fff;
}

.theme--light.v-list-item--active:hover::before, .theme--light.v-list-item--active::before{
  opacity: 1;
}

.theme--dark.v-list-item--active:hover::before, .theme--dark.v-list-item--active::before{
  opacity: 1;
}

.v-list .v-list-item--active:not(.darkToggle){
  color: #fff;
}

.v-list-item:not(.noHover):hover{
  border-radius: 15px 0 0 15px;
  background-color: #CF112D;
  color: #fff !important;
  margin-left: 5px;
  margin-right: -10px;
  opacity: 0.4;
  .theme--light.v-icon:not(.darkToggle){
    color: #fff !important;
  }
}

.v-list-item:hover > .v-list-item--dense .v-list-item__title, .v-list-item--dense .v-list-item__subtitle, .v-list--dense .v-list-item .v-list-item__title, .v-list--dense .v-list-item .v-list-item__subtitle{
  z-index: 1;
}
.noHover:hover, {
  opacity: 1;
  background-color: unset;
  margin-left: unset;
  margin-right: unset;
}

.darkToggle:hover {
  background-color: unset;
  margin-left: unset;
  margin-right: unset;

  .v-list-item {
    color: red;

  }
}

</style>
